"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MultiplierRegistryFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "contract IRarityRegistry",
                name: "_rarityRegistry",
                type: "address",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [],
        name: "COMMON_MULTIPLIER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "EPIC_MULTIPLIER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "LEGENDARY_MULTIPLIER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "RARE_MULTIPLIER",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "tokenId",
                type: "uint256",
            },
        ],
        name: "getMultiplier",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256[]",
                name: "_ids",
                type: "uint256[]",
            },
        ],
        name: "getMultipliers",
        outputs: [
            {
                internalType: "uint256[]",
                name: "",
                type: "uint256[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "rarityRegistry",
        outputs: [
            {
                internalType: "contract IRarityRegistry",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class MultiplierRegistryFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(_rarityRegistry, overrides) {
        return super.deploy(_rarityRegistry, overrides || {});
    }
    getDeployTransaction(_rarityRegistry, overrides) {
        return super.getDeployTransaction(_rarityRegistry, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.MultiplierRegistryFactory = MultiplierRegistryFactory;
MultiplierRegistryFactory.bytecode = _bytecode;
MultiplierRegistryFactory.abi = _abi;
//# sourceMappingURL=MultiplierRegistryFactory.js.map